import React from "react";
import { Card, Row, Col, Typography, Button } from "antd";
import {
  ArrowLeftOutlined,
  HomeOutlined,
  ClusterOutlined,
  TagsOutlined,
  UserOutlined,
  TeamOutlined,
  BankOutlined,
  SettingOutlined,
  EnvironmentOutlined,
  CreditCardOutlined,
  AppstoreOutlined
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import "./settingsDashboard.css";
import { accessChecker } from "../../lib/functions";

const { Title } = Typography;

const settingsMenu = [
  {
    key: "warehouse",
    value: "warehouse_entry",
    label: "Warehouses",
    link: "/settings/warehouses",
    icon: <HomeOutlined style={{ fontSize: 22, color: "#333" }} />, //color: "#1677ff"
  },
  {
    key: "branches",
    value: "branch_entry",
    label: "Branches",
    link: "/settings/branch-manage",
    icon: <ClusterOutlined style={{ fontSize: 22, color: "#333" }} />, //color: "#52c41a"
  },
  {
    key: "tags",
    value: "tag_manage",
    label: "Tags",
    link: "/settings/tags",
    icon: <TagsOutlined style={{ fontSize: 22, color: "#333" }} />, //color: "#722ed1"
  },
  {
    key: "users",
    value: "user_entry",
    label: "Users",
    link: "/settings/user-manage",
    icon: <UserOutlined style={{ fontSize: 22, color: "#333" }} />, //color: "#fa8c16"
  },
  {
    key: "user_roles",
    value: "user_role_manage",
    label: "User Roles",
    link: "/settings/user-role-manage",
    icon: <TeamOutlined style={{ fontSize: 22, color: "#333" }} />, //color: "#eb2f96"
  },
  {
    key: "module_access",
    value: "module_access_settings",
    label: "Module Access",
    link: "/settings/module-access",
    icon: <AppstoreOutlined style={{ fontSize: 22, color: "#333" }} />,
  },
  {
    key: "company_profile",
    value: "company_profile",
    label: "Company Profile",
    link: "/settings/institution-profile",
    icon: <BankOutlined style={{ fontSize: 22, color: "#333" }} />, //color: "#13c2c2"
  },
  {
    key: "location_entry",
    value: "location_entry",   // permission key
    label: "Locations",
    link: "/settings/location-manage",
    icon: <EnvironmentOutlined style={{ fontSize: 22, color: "#333" }} />,
  },
  {
    key: "activities",
    value: "activities",
    label: "Activities",
    link: "/settings/activities",
    icon: <HomeOutlined style={{ fontSize: 22, color: "#333" }} />, //color: "#1677ff"
  },
  {
    key: "subscription_info",
    value: "subscription_info",
    label: "Subscription",
    link: "/settings/subscription-info",
    icon: <CreditCardOutlined style={{ fontSize: 22, color: "#333" }} />,
  }
];

const SettingsDashboard = () => {
  const navigate = useNavigate();
  const filteredMenuData = settingsMenu.filter((menuItem) =>
    accessChecker(menuItem.value)
  );
  return (
    <div className="settingsDashboard">
      <div style={{ display: "flex", alignItems: "center" }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
          onClick={() => navigate(-1)}
          data-testid="settings-back-button"
        />
        <Title level={3} style={{ margin: 0 }}>
          <SettingOutlined style={{ marginRight: 8, color: "#595959" }} />
          Settings
        </Title>
      </div>


      <Row gutter={[16, 16]}>
        {filteredMenuData
          ?.sort((a, b) => a.label.localeCompare(b.label))
          .map((item) => (
            <Col xs={24} sm={12} md={8} lg={6} key={item.key}>
              <Link to={item.link}>
                <Card hoverable className="settingsCard">
                  <div className="cardContent">
                    {item.icon}
                    <span className="cardLabel">{item.label}</span>
                  </div>
                </Card>
              </Link>
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default SettingsDashboard;
